/// <reference path="../../ui/types.d.ts" />
import { FC } from 'react';

interface InstallPageProps {
    name: string;
}

export const InstallPage: FC<InstallPageProps> = ({ name }) => (
    <div className="i_w center">
        <div>
            <h1>Looks like {name} is not installed yet!</h1>
            <p>
                Contact your organization administrator to install it. More info on{' '}
                <a href="https://support.crowdin.com">Link to how to install</a>
            </p>
        </div>
    </div>
);
